var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionWaifu = function SvgIcnMintOptionWaifu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    fill: "#020113",
    stroke: "#88B8FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#020113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.683 9.332a2.508 2.508 0 0 0-.077-.104s0-.002-.002-.003a.689.689 0 0 0-1.104.811c.033.04.063.083.093.125a2.592 2.592 0 1 1-4.596 2.28 2.592 2.592 0 1 1-4.526-2.373.689.689 0 0 0-1.062-.866 3.94 3.94 0 0 0-.84 2.439 3.963 3.963 0 0 0 3.964 3.962 3.937 3.937 0 0 0 2.464-.863 3.962 3.962 0 0 0 5.685-5.409Z",
    fill: "#88B8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53 13.312a.916.916 0 1 0 0-1.831.916.916 0 0 0 0 1.831ZM14.464 13.312a.916.916 0 1 0-.001-1.832.916.916 0 0 0 .002 1.832Z",
    fill: "#fff"
  })));
};
export default SvgIcnMintOptionWaifu;